import { Alert } from '@mantine/core'
import Link from 'next/link'

import * as Types from 'declarations'
import SectionHeader from './components/SectionHeader'
import HTMLContent from 'components/HTMLContent'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Gear = ({
	trip: {
		name,
		jsonData: { gear, trekOrClimb, highLevelInfo },
	},
}: Props) => {
	if (!gear) return <></>

	const isClimb = trekOrClimb === Types.App.DataTypes.TrekOrClimb.CLIMB

	const highestPoint = highLevelInfo?.climb?.maxElevation

	const isSixToSevenClimb =
		!!highestPoint && highestPoint > -6000 && highestPoint <= 7000

	return (
		<div id="gear-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} Gear Packing List `}
				subtitle={`What To Take to ${
					trekOrClimb === Types.App.DataTypes.TrekOrClimb.TREK
						? 'trek'
						: 'climb'
				} ${name}`}
				section={Types.App.DataTypes.FeedbackSection.GEAR}
			/>

			{isClimb && isSixToSevenClimb && (
				<Alert title="Guide" variant={'outline'}>
					Checkout this complete guide to{' '}
					<Link href="/articles/what-and-how-to-pack-for-a-6000-meter-mountain-climb-complete-guide-and-ultimate-gear-checklist-and-how-to-best-use-the-gear-effectively">
						packing for 6000 meters
					</Link>
				</Alert>
			)}

			{gear.description && (
				<HTMLContent
					id="gear-description"
					html={gear.description}
				></HTMLContent>
			)}
		</div>
	)
}

export default Gear
